import { useStoreContextStore } from '@core/store/storeContextStore';

export function useStoreContext() {
  const accountId = useStoreContextStore((s) => s.accountId);
  const channelId = useStoreContextStore((s) => s.channelId);
  const locationId = useStoreContextStore((s) => s.locationId);
  const brandId = useStoreContextStore((s) => s.brandId);
  const brandName = useStoreContextStore((s) => s.brandName);
  const companyId = useStoreContextStore((s) => s.companyId);
  const companyName = useStoreContextStore((s) => s.companyName);
  const accountCountry = useStoreContextStore((s) => s.accountCountry);
  const customerLocation = useStoreContextStore((s) => s.customerLocation);
  const isRuntimeSwitching = useStoreContextStore((s) => s.isRuntimeSwitching);
  const priceField = useStoreContextStore((s) => s.priceField);
  const currencyConfig = useStoreContextStore((s) => s.currencyConfig);
  const setLocation = useStoreContextStore((s) => s.setLocation);
  const setBrand = useStoreContextStore((s) => s.setBrand);
  const setRuntimeSwitching = useStoreContextStore((s) => s.setRuntimeSwitching);
  const setCustomerLocation = useStoreContextStore((s) => s.setCustomerLocation);
  const setAccountCountry = useStoreContextStore((s) => s.setAccountCountry);
  const setChannel = useStoreContextStore((s) => s.setChannel);
  const setCurrency = useStoreContextStore((s) => s.setCurrency);

  return {
    accountId,
    channelId,
    locationId,
    brandId,
    brandName,
    companyId,
    companyName,
    accountCountry,
    customerLocation,
    isRuntimeSwitching,
    priceField,
    currencyConfig,
    isReady: Boolean(accountId && channelId && locationId),
    setLocation,
    setBrand,
    setRuntimeSwitching,
    setCustomerLocation,
    setAccountCountry,
    setChannel,
    setCurrency,
  };
}
